module.exports = "<div class=\"loading-screen\">\n    {{'Loading...' | translate}}\n    <div class=\"progress progress-striped active\">\n        <div class=\"progress-bar loading-screen__bar\"></div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/shared/loading-screen.html
// module id = 1
// module chunks = 0